<template class="heading">
  <div class="siimple-table-row">
    <div class="heading siimple-table-cell">
      <b v-if="heading != null">{{ heading }}</b>
      <span v-if="heading == null" class="points">{{ item.points }} poeng</span>
    </div>
    <div class="emoji siimple-table-cell">
      <emoji v-for="(emoji, index) in emojisArray" :key="index" :value="emoji" />
    </div>
    <div class="answer siimple-table-cell">
      <input v-if="!correct" :class="{ wrong: wrong }" v-model="answer" placeholder="Skriv svar" type="text"
        class="siimple-input siimple-input--fluid" @blur="checkIfCorrect" @keyup.enter="checkIfCorrect" />
      <div v-if="correct" class="correct siimple-input siimple-input--fluid">
        Riktig svar!
      </div>
    </div>
  </div>
</template>

<script>
import Emoji from '@/components/Emoji';
import GraphemeSplitter from 'grapheme-splitter';
import HTTP from '@/utils/http-common';

const splitter = new GraphemeSplitter();

export default {
  name: 'QuizItem',
  components: {
    Emoji
  },
  props: {
    heading: {
      type: String,
      required: false,
      default: null
    },
    solutions: {
      type: Array,
      required: false,
      default: () => []
    },
    item: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      answer: '',
      wrong: false,
      correct: false
    };
  },
  computed: {
    emojisArray() {
      return splitter.splitGraphemes(this.item.text);
    }
  },
  watch: {
    'item.answered': {
      immediate: true,
      handler(newVal) {
        // eslint-disable-next-line no-console
        if (newVal) {
          this.setQuizStatus(true);
        } else {
          this.resetQuizStatus();
        }
      }
    }
  },
  methods: {
    checkIfCorrect() {
      if (this.answer === '') {
        this.resetQuizStatus();
      } else if (this.solutions.length > 0) {
        // If a solution has been provided in the frontend code, just check locally(for Intro/example quiz)
        if (this.solutions.indexOf(this.answer.trim().toLowerCase()) > -1) {
          this.setQuizStatus(true);
        } else {
          this.setQuizStatus(false);
        }
      } else {
        // TODO: A bit hacky to use localstorage for this, but hey
        let username = '';
        let email = '';
        if (localStorage) {
          username = localStorage.getItem('username');
          email = localStorage.getItem('email');
        }
        // ...otherwise check serverside (TODO)
        HTTP.post('quizzes/check', null, {
          params: {
            email: email,
            name: username,
            quizId: this.item.id,
            answer: this.answer
          }
        })
          .then(response => {
            this.setQuizStatus(response.data);
          })
          .catch(e => {
            // eslint-disable-next-line no-console
            console.error(e);
          });
      }
    },
    setQuizStatus(isCorrect) {
      this.correct = isCorrect;
      this.wrong = !isCorrect;
    },
    resetQuizStatus() {
      this.correct = false;
      this.wrong = false;
      this.answer = '';
    }
  }
};
</script>

<style scoped>
.siimple-input.correct {
  background-color: #50e3c2;
  color: white;
}

.siimple-input.correct::placeholder {
  color: white;
}

.siimple-input.wrong {
  background-color: #ee675d;
  color: white;
}

.siimple-input.wrong::placeholder {
  color: white;
}

.siimple-table-cell {
  line-height: 34px;
  padding: 5px 0;
}

.siimple-table-cell,
.siimple-table-body .siimple-table-row:not(:last-child) .siimple-table-cell {
  border: 0;
}

.siimple-table-cell {
  text-align: right;
}

.answer {
  width: 30%;
}

.heading {
  text-align: left;
  width: 70px;
}

.points {
  background-color: lightblue;
  padding: 5px;
  border-radius: 10px;
  font-size: small;
}

@media (max-width: 480px) {
  .siimple-table-cell {
    text-align: left;
  }


  .siimple-table-cell.answer {
    padding-bottom: 26px;
    padding-top: 0;
  }

  .siimple-table-cell {
    line-height: 24px;
    display: block;
  }

  .answer {
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/QuizItem.vue